import React from "react";

// "Boshqa admin o'zgartirgan" bayroqchasi — Mapping modali (DnD) va Excel import natijasida
// bir xil ko'rinishda qayta ishlatiladi (AKFA_MAPPING_EXCEL_IMPORT_FRONTEND.md).
export default function ConflictBanner({ title, text, items, renderItem, action }) {
    return (
        <div
            role="alert"
            className="flex flex-wrap items-start justify-between gap-3.5 px-4 py-3 bg-amber-50 border-b border-gray-200 text-sm text-gray-900"
        >
            <div>
                <b className="text-amber-800">{title}</b> {text}
                <ul className="mt-1.5 pl-5 list-disc">
                    {items.map((item, index) => (
                        <li key={item.key ?? index}>{renderItem(item)}</li>
                    ))}
                </ul>
            </div>
            {action}
        </div>
    );
}
